import { render, staticRenderFns } from "./CalendarSideBarNavigation.vue?vue&type=template&id=fe9d96f4&scoped=true"
import script from "./CalendarSideBarNavigation.vue?vue&type=script&lang=ts"
export * from "./CalendarSideBarNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9d96f4",
  null
  
)

export default component.exports